import { useState, useEffect, useMemo } from 'react';
import ModuleService from '../../../services/module_service';
import ActionService from '../../../services/action_service';

const Matriz = (props) => {
    const [modules, setModules] = useState([]);
    const [actions, setActions] = useState([]);

    const moveToEndBy = (arr, key, value) => {
        const index = arr.findIndex(
            (item) => String(item[key]) === String(value)
        );
        if (index === -1) return arr;
        const newArr = [...arr];
        const [item] = newArr.splice(index, 1);
        newArr.push(item);

        return newArr;
    };

    useEffect(() => {
        (async () => {
            props.setLoading(true)
            try {
                const modulesData = await ModuleService.getAll()
                if (props.logout(modulesData)) return;
                const actionsData = moveToEndBy(await ActionService.getAll(), 'Name', 'Especial')
                setModules(modulesData || []);
                setActions(actionsData || []);
            } catch (e) {
                props.message(e?.message || e, "error")
            } finally {
                props.setLoading(false)
            }
        })();
    }, []);

    const rows = useMemo(() => {
        return modules.map((module) => ({
            ...module,
            cells: actions.map((action) => ({
                moduleId: module.Id,
                actionId: action.Id,
                actionName: action.Name,
            })),
        }));
    }, [modules, actions]);

    return {
        modules,
        actions,
        rows
    };
};

export default Matriz;
